module.exports = __webpack_public_path__ + "static/media/marvel.b344b76d.jpg";